<template>
    <div v-if="modalIsOpenOrUsingButtonText()" class="modal-wrapper" :class="wrapper_classes">

        <div @click="toggle" class="trigger" :class="button_classes">{{button_text}}</div>
        <div class="modal" v-if="open">
            <div class="modal--backdrop" @click.stop="toggle"></div>
            <div class="modal--content" :style="{height:cardHeight}">
                <div v-if="!disable_background_click_to_close" @click.stop="closeModalViaBtn" class="btn btn-secondary btn-close cursor">&times;</div>
                <!-- <div class="btn-close" v-if="!disable_background_click_to_close"><span @click="closeModalViaBtn" class="btn btn-secondary cursor">&times;</span></div> -->
                <slot />
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Modal',
        data: function () {
            return {
                open: false
            }
        },
        props: {
            title: String,
            button_text: String,
            button_classes: String,
            title_classes: String,
            wrapper_classes: String,
            cardHeight: String,
            disable_background_click_to_close: {
                type: Boolean,
                default: false,
            },
            closeModalCallback: Boolean,
        },
        methods: {
            modalIsOpenOrUsingButtonText(){
                //I use this to remove div from html to avoid pushing items lower in the display
                return this.open || this.button_text
            },
            closeModalViaBtn(){
                if (this.disable_background_click_to_close) return;
                this.closeModal();
                
            },
            toggle () {
                if (this.disable_background_click_to_close) return;
                this.open = !this.open
            },
            openModal(){
                this.open = true;
            },
            closeModal(){
                this.open = false;
            },
            callback(functionName){
                functionName();
            }
        },
        watch: {
            closeModalCallback: function () {
                this.closeModal()
            },
        }
    }
</script>

<style lang="scss" scoped>
    .modal-wrapper {
        display: inline-block;
        
    }
    .trigger {
        cursor: pointer;
    }
    .btn-close {
        position: absolute;
        max-height: 20px;
        max-width: 20px;
        margin-top: -25px;
        top: 30px;
        right: 25px;
        color: $primary;
        border: solid 1px $primary;
        z-index: 1;
        font-size: 24px;
        padding: 2px;
        display: flex;
        
        // span {
        //     flex: 0;
        //     margin-top: 0px;
        //     margin-left: auto;
        //     vertical-align: middle;
        // }
        justify-content: center;
        align-items: center;
    }
    .modal {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 3000;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: modal-fade 300ms ease forwards;
        opacity: 0;

        &--backdrop {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
        }

        &--content {
            display: flex;
            border-radius: 4px;
            flex-direction: column;
            -webkit-overflow-scrolling: touch;
            animation: card-slide 300ms ease forwards;
            animation-delay: 100ms;
            transform: translate(0, 3rem);
            opacity: 0;
            z-index: 2000;
            background-color: $white;
            padding: 0px;
            max-width: 90%;
        }

    }
    @keyframes modal-fade {
        to {
            opacity: 1;
        }
    }
    @keyframes card-slide {
        to {
            opacity: 1;
            transform: translate(0,0);
        }
    }
</style>

